import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideFunnelSampleContentInitializer } from 'shared/src/services/funnel-sample-content.service';
import { PROJECT_NAME, ProjectNames } from 'shared/src/tokens';
import { provideStatsigInitializer } from '../../../funnel/src/app/app.config';
import { FunnelFlowService } from '../../../funnel/src/app/services/funnel-flow.service';
import { PaywallService } from '../../../funnel/src/app/services/paywall.service';
import { QuizRouteReuseStrategy } from '../../../funnel/src/app/services/quiz-route-reuse-strategy';
import { routes } from './app.routes';
import { RomanceFunnelFlowService } from './services/romance-funnel-flow.service';
import { RomancePaywallService } from './services/romance-paywall.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(),
    provideAnimations(),
    {
      provide: PROJECT_NAME,
      useValue: ProjectNames.ROMANCE_FUNNEL,
    },
    {
      provide: RouteReuseStrategy,
      useClass: QuizRouteReuseStrategy,
    },
    provideFunnelSampleContentInitializer(),
    provideStatsigInitializer(),
    {
      // Override the FunnelFlowService with the romance variant
      provide: FunnelFlowService,
      useClass: RomanceFunnelFlowService,
    },
    {
      provide: PaywallService,
      useClass: RomancePaywallService,
    },
  ],
};
